/* SANIKB: isolated FR/DE/ES pagination helpers; no code is loaded on English pages. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SanikbLocalePagination = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  function pageCount(total, size) {
    if (!Number.isInteger(total) || total < 0 || !Number.isInteger(size) || size < 1) throw new Error('Invalid pagination metadata');
    return Math.max(1, Math.ceil(total / size));
  }
  function pageSlice(items, page, size) {
    if (!Number.isInteger(page) || page < 1 || page > pageCount(items.length, size)) throw new Error('Page outside collection');
    return items.slice((page - 1) * size, page * size);
  }
  function pageUrl(current, page) {
    var u = new URL(current);
    u.hash = '';
    u.searchParams.delete('view');
    u.searchParams.delete('section_id');
    u.searchParams.delete('sections');
    if (page === 1) u.searchParams.delete('page');
    else u.searchParams.set('page', String(page));
    return u.toString();
  }
  function bulkUrl(current, view, page) {
    if (!/^skp-batch-[cb][a-f0-9]{12}$/.test(view)) throw new Error('Unexpected bulk view');
    var u = new URL(pageUrl(current, page));
    if (!/^\/(fr|de|es)(\/|$)/.test(u.pathname)) throw new Error('Bulk view is limited to published locale paths');
    u.searchParams.set('view', view);
    u.searchParams.set('page', String(page));
    return u.toString();
  }
  async function orderedPool(count, limit, worker) {
    var results = new Array(count), cursor = 0;
    async function run() {
      while (cursor < count) {
        var index = cursor++;
        results[index] = await worker(index + 1);
      }
    }
    await Promise.all(Array.from({ length: Math.min(limit, count) }, run));
    return results;
  }
  /* Validate the entire catalogue before changing the live DOM. Partial batches are errors. */
  function mergeBatches(batches, total, size, existing, key, compatible) {
    var expectedPages = pageCount(total, size);
    if (batches.length !== expectedPages) throw new Error('Missing bulk batch');
    var original = new Map(), seen = new Set(), ordered = [];
    existing.forEach(function (item) {
      var id = key(item);
      if (!id || original.has(id)) throw new Error('Invalid SSR identities');
      original.set(id, item);
    });
    batches.forEach(function (batch, index) {
      var expected = Math.min(size, Math.max(0, total - index * size));
      if (!Array.isArray(batch) || batch.length !== expected) throw new Error('Incomplete bulk batch ' + (index + 1));
      batch.forEach(function (item) {
        var id = key(item);
        if (!id || seen.has(id)) throw new Error('Duplicate or missing product identity');
        seen.add(id);
        var retained = original.get(id);
        if (retained && compatible && !compatible(retained, item)) throw new Error('SSR / bulk configuration mismatch');
        ordered.push(retained || item);
      });
    });
    if (ordered.length !== total || Array.from(original.keys()).some(function (id) { return !seen.has(id); })) throw new Error('SSR catalogue drift');
    return ordered;
  }
  function dataCompatible(a, b) {
    /* Preserve the actual locale product/filter values; ignore only runtime enhancement state. */
    var ignored = new Set(['bound', 'mostPromoted', 'popularRank', 'skLoaded']);
    var keys = Array.from(new Set(Object.keys(a.dataset).concat(Object.keys(b.dataset))));
    return keys.every(function (key) { return ignored.has(key) || String(a.dataset[key] || '') === String(b.dataset[key] || ''); });
  }
  async function loadCatalogue(options) {
    var batches = await orderedPool(pageCount(options.total, options.batchSize), 2, async function (page) {
      var response = await options.fetch(bulkUrl(options.url, options.view, page), { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } });
      if (!response.ok) throw new Error('Bulk HTTP failure');
      var document = options.parse(await response.text());
      var container = document.querySelector(options.selector);
      if (!container || Number(container.dataset.skpTotal) !== options.total || Number(container.dataset.skpCurrent) !== page || Number(container.dataset.skpBatchSize) !== options.batchSize) throw new Error('Bulk response does not match request');
      return Array.from(container.querySelectorAll(options.itemSelector));
    });
    return mergeBatches(batches, options.total, options.batchSize, options.existing, options.key, options.compatible);
  }
  function normalizeFilterUrl(current, hash) {
    var u = new URL(pageUrl(current, 1));
    u.hash = hash || '';
    return u.toString();
  }
  function canonical(base, page, total, size) {
    var u = new URL(base);
    u.search = '';
    u.hash = '';
    if (!Number.isInteger(page) || page < 1 || page > pageCount(total, size)) return { valid: false, href: u.toString() };
    if (page > 1) u.searchParams.set('page', String(page));
    return { valid: true, href: u.toString() };
  }
  return { pageCount: pageCount, pageSlice: pageSlice, pageUrl: pageUrl, bulkUrl: bulkUrl, orderedPool: orderedPool, mergeBatches: mergeBatches, dataCompatible: dataCompatible, loadCatalogue: loadCatalogue, normalizeFilterUrl: normalizeFilterUrl, canonical: canonical };
});
